<template>
    <div>
        <div class="content mt-20">
            <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
        </div>
        <div class="flex flex-right mt-20">
            <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
        </div>
    </div>

</template>

<script>
    import LoadButton from "../../components/LoadButton";
    import Pagination from "../../components/Pagination";
    import SmartTable from "../../components/SmartTable";
    import FormDialog from "../../components/FormDialog";
    import UploadImg from "../../components/UploadImg";
    import Dropdown from "../../components/Dropdown";
    import UploadButton from "../../components/UploadButton";
    export default{
        components: {
            Dropdown,
            UploadImg,
            FormDialog,
            SmartTable,
            Pagination,
            LoadButton,
            UploadButton
        },
        data(){
            return {
                searchParams: {
                    page: 1
                },
                searchData: {},
                opt: [

                ],
                labels: [
                    {prop: 'companyName', label: '公司名称'},
                    {prop: 'content', label: '内容'},
                    {prop: 'createAt', label: '时间'},

                ],
                temp:{}
            }
        },
        computed:{
            list(){
                let  arr = []
                for(var i in this.$store.state.tasKeyMap){
                    arr.push({id:i,name:this.$store.state.tasKeyMap[i]})
                }
                return arr
            },
        },
        mounted(){
            this.getList()
        },
        methods: {
            search(stop){
                this.searchParams.page = 1
                this.getList(stop)
            },
            toPage(page){
                this.searchParams.page = page
                this.getList()
            },
            getList(callback){
                this.$http$({method: 'get', url: "/smartMeter/message/company",data:this.searchParams,  load: 1}, (data) => {
                    callback ? callback() : ''
                    this.searchData = data
                })
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/superAdmin/Message.vue